export default [{name:'网易音乐',url:'https://music.163.com/#/search/m/?s='},{name:'QQ音乐',url:'https://y.qq.com/portal/search.html#page=1&searchid=1&remoteplace=txt.yqq.top&t=song&w='},{name:'Apple Music',url:'https://music.apple.com/cn/search?term='},{name:'极客音乐',url:'http://www.jikexq.cc/music/?keyword='},{name:'ZZ123',url:'https://zz123.com/search/?key='},{name:'musicenc',url:'https://www.musicenc.com/?search='},{name:'slider',url:'https://slider.kz/#'},{name:'mp3paw',url:'https://v3.mp3paw.link/mp3-music/#'},{name:'歌曲宝',url:'https://www.gequbao.com/s/'}];


//////////////////
// WEBPACK FOOTER
// ./src/assets/yaml/searchMusic.yaml
// module id = null
// module chunks = 